import type { TReplaceOptions } from 'cng-common/features/translations/components/translation/models/replaceOptions'

const ENTITIES: Record<string, string> = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&nbsp;': ' ',
}

/**
 * A translation as `Translation` shows it, reduced to the plain text a slide prints.
 *
 * Params are filled the way `Translation` fills them. A translation may carry markup, which the
 * screen renders and a slide cannot, so the markup is dropped and its entities decoded; a closed
 * block or a line break leaves a space, so two paragraphs don't run into one word.
 */
export const toExportText = (translated: string, params: TReplaceOptions[] = []) =>
  params
    .reduce((text, { key, value }) => text.replaceAll(key, value), translated)
    .replace(/<\/(p|div|li)>|<br\s*\/?>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&(amp|lt|gt|quot|#39|nbsp);/g, (entity) => ENTITIES[entity])
    .replace(/\s+/g, ' ')
    .trim()
